// extracted by mini-css-extract-plugin
export var askAiIcon = "_jy-9";
export var container = "_jy-0";
export var groupSeparator = "_jy-a";
export var highlight = "_jy-4";
export var resultIcon = "_jy-5";
export var resultItem = "_jy-7";
export var resultSubtitle = "_jy-3";
export var resultTitle = "_jy-2";
export var resultsList = "_jy-1";
export var searchGroup = "_jy-6";
export var selected = "_jy-8";